import IRequest from "../../IRequest";

export interface IHistoricoFinanceiro {
    reqHistorico: IRequest<THistoricoFinanceiro>,
    dataHistorico: THistoricoFinanceiro[]
  }

export type THistoricoFinanceiro = {
  id: number;
  nome: string;
  descricao: string;
}

export const defValueHistoricoFinanceiro: THistoricoFinanceiro = 
{
  id: 0,
  nome: '',
  descricao: ''
}